export default __webpack_public_path__ + "static/media/Pistol_5.5a018649.png";